<template>
  <div class="container-fluid mt-4" dir="rtl">
    
    <!-- 1. لوحة التحكم -->
    <div class="card shadow-sm mb-4 no-print border-top-danger">
      <div class="card-header bg-white py-3">
        <h5 class="mb-0 text-danger fw-bold">
          <i class="fas fa-user-times ms-2"></i> طباعة كشوف الغياب المفرغة (للإدارة بالكامل)
        </h5>
      </div>
      <div class="card-body">
        <div class="row g-3 align-items-end">
          <div class="col-md-4">
            <label class="fw-bold small">الإدارة التعليمية</label>
            <select v-model="form.admin_id" class="form-select">
              <option value="">-- اختر الإدارة --</option>
              <option v-for="adm in administrations" :key="adm.id" :value="adm.id">{{ adm.dep_name }}</option>
            </select>
          </div>
          <div class="col-md-4">
            <label class="fw-bold small">اسم المادة</label>
            <input type="text" v-model="form.subject_name" class="form-control" placeholder="مثال: اللغة العربية">
          </div>
          <div class="col-md-4">
            <button @click="fetchSchools" class="btn btn-danger w-100 fw-bold" :disabled="loading || !form.admin_id">
              <span v-if="loading" class="spinner-border spinner-border-sm"></span>
              <span v-else>عرض وتجهيز الكشوف</span>
            </button>
          </div>
        </div>
        
        <div class="mt-3 text-end border-top pt-3" v-if="schoolsList.length > 0">
           <button @click="printReport" class="btn btn-dark px-5 fw-bold">
             <i class="fas fa-print ms-2"></i> طباعة الكل ({{ schoolsList.length }} مدرسة)
           </button>
        </div>
      </div>
    </div>

    <!-- 2. منطقة الطباعة -->
    <div id="printMe" v-if="schoolsList.length > 0">
      
      <!-- حلقة تكرار: كشف لكل مدرسة في ورقة مستقلة -->
      <div v-for="(school, index) in schoolsList" :key="index" class="school-sheet">
        
        <div class="sheet-content border border-2 border-dark p-4 position-relative" style="min-height: 98vh;">
            
            <!-- الترويسة -->
            <div class="header text-center mb-2 pb-2 border-bottom border-dark">
                <div class="row align-items-center mb-2">
                    <div class="col-4 text-start">
                        <h6 class="fw-bold m-0 fs-6">محافظة شمال سيناء</h6>
                        <h6 class="fw-bold m-0 fs-6">  مديرية التربية والتعليم</h6>
                        <h6 class="fw-bold m-0 fs-6">لجنة النظام والمراقبة</h6>
                      
                    </div>
                    <div class="col-4">
                        <h3 class="fw-bold text-decoration-underline mb-1">كشف حصر الغياب</h3>
                        <div class="badge bg-white text-dark border border-dark fs-5">
                            مادة: {{ form.subject_name || '....................' }}
                        </div>
                    </div>
                    <div class="col-4 text-center">
                        
                        <h6 class="fw-bold m-0 fs-6">الشهادة الإعدادية 2026</h6>
                    </div>
                </div>

                <!-- اسم المدرسة -->
                <div class="school-box bg-light border border-dark p-2 rounded mb-3">
                    <h4 class="m-0 fw-bold">مدرسة: {{ school.school_name }}</h4>
                      <!-- <h6 class="fw-bold m-0 fs-6"> {{ getAdminName() }}</h6> -->
                </div>

                <!-- ============================================ -->
                <!-- التنبيه الهام (المضاف) -->
                <!-- ============================================ -->
                <div class="alert alert-light border-2 border-dark text-center py-2 mb-2 instruction-box">
                    <i class="fas fa-exclamation-triangle text-danger me-2"></i>
                    <strong class="text-decoration-underline">تنبيه هام للسيد مدير المدرسة:</strong>
                    <span class="d-block mt-1 fw-bold fs-6">
                        يرجى التكرم بكتابة أرقام جلوس وأسماء الطلاب المتغيبين عن امتحان هذه المادة في الجدول أدناه واعتماده بختم المدرسة.
                    </span>
                </div>
                <!-- ============================================ -->

            </div>

            <!-- الجدول الفارغ -->
            <table class="table table-bordered border-dark text-center align-middle mb-2 custom-table">
                <thead class="bg-secondary text-white print-header-bg">
                    <tr>
                        <th width="8%">م</th>
                        <th width="20%">رقم الجلوس</th>
                        <th width="45%">اسم الطالب (رباعياً)</th>
                        <th width="27%">ملاحظات</th>
                    </tr>
                </thead>
                <tbody>
                    <!-- 20 صف فارغ -->
                    <tr v-for="n in 20" :key="n" class="empty-row">
                        <td class="fw-bold">{{ n }}</td>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr>
                </tbody>
            </table>

            <!-- التذييل -->
            <div class="footer-section mt-auto pt-3">
                <!-- إحصاء سريع -->
                <div class="d-flex justify-content-between border border-dark p-2 mb-4 fw-bold small bg-light">
                    <span>عدد الغياب: ( ........... ) طالب</span>
                    <span>عدد الحضور: ( ........... ) طالب</span>
                    <span>الإجمالي: ( ........... ) طالب</span>
                </div>

                <div class="row text-center fw-bold fs-5">
                    <div class="col-4">
                        <!-- <p class="mb-5 text-decoration-underline">مراقب الدور</p>
                        <p>....................</p> -->
                    </div>
                    <div class="col-4">
                        <!-- <p class="mb-5 text-decoration-underline">المراقب الأول</p>
                        <p>....................</p> -->
                    </div>
                    <div class="col-4">
                        <p class="mb-5 text-decoration-underline">مدير المدرسة (رئيس اللجنة)</p>
                        <p>....................</p>
                    </div>
                </div>
            </div>

        </div>
        
        <!-- فاصل صفحات (هام جداً) -->
        <div class="page-break"></div>

      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api/axios';

export default {
  name: "AbsenceSheetEmpty",
  data() {
    return {
      loading: false,
      administrations: [],
      schoolsList: [],
      form: { admin_id: "", subject_name: "" }
    };
  },
  mounted() {
    this.fetchAdmins();
  },
  methods: {
    async fetchAdmins() {
        const res = await api.get('getadmins');
        this.administrations = res.data;
    },
    async fetchSchools() {
        this.loading = true;
        try {
            // نستخدم نفس الراوت السابق لجلب قائمة المدارس فقط
            const res = await api.get(`/getschoolswithmange/${this.form.admin_id}`);
            this.schoolsList = res.data;
        } catch(e) { alert("خطأ"); } 
        finally { this.loading = false; }
    },
    getAdminName() {
        const a = this.administrations.find(x => x.id == this.form.admin_id);
        return a ? a.dep_name : '';
    },
    printReport() { this.$htmlToPaper("printMe"); }
  }
};
</script>

<style scoped>
.border-top-danger { border-top: 4px solid #dc3545; }

@media print {
    @page { 
        size: A4 portrait; 
        margin: 10mm; /* هوامش مناسبة للطباعة */
    }
    
    .no-print { display: none !important; }
    #printMe { visibility: visible; position: absolute; left: 0; top: 0; width: 100%; }

    .school-sheet {
        page-break-after: always;
        min-height: 100vh;
        display: flex;
        flex-direction: column;
    }

    .custom-table th, .custom-table td {
        border: 2px solid #000 !important;
        font-size: 13pt;
        height: 32px; /* ضبط الارتفاع ليكفي الصفحة */
        padding: 2px !important;
    }

    /* إظهار التنبيه بوضوح */
    .instruction-box {
        border: 2px solid #000 !important;
        background-color: #f8f9fa !important;
        -webkit-print-color-adjust: exact;
    }

    .print-header-bg {
        background-color: #000 !important;
        color: #fff !important;
        -webkit-print-color-adjust: exact;
    }
    
    .bg-light { background-color: #f0f0f0 !important; -webkit-print-color-adjust: exact; }
    
    /* إخفاء الأيقونات في الطباعة */
    .fas { display: none; }
}
</style>